import SectionHero from "components/SectionHero/SectionHero";
import rightImg from "images/about-us.svg";
import React, {FC} from "react";
import SectionFounder from "./SectionFounder";
import {Helmet} from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import SectionBuyACoffee from "components/SectionBuyACoffee/SectionBuyACoffee";
import SectionVisionaries from "./SectionVisionaries";
import SectionHero2 from "../PageHome/SectionHero2";

export interface PageAboutProps {
    className?: string;
}

const PageAbout: FC<PageAboutProps> = ({className = ""}) => {
    return (
        <div
            className={`PageAbout overflow-hidden relative ${className}`}
            data-id="PageAbout"
        >
            <Helmet>
                <title>About | CryptoVerse</title>
            </Helmet>

            <BgGlassmorphism/>

            <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
                <SectionHero2
                    rightImg={rightImg}
                    heading="Building Toward better."
                    btnText=""
                    subHeading="The CryptoVerse team believes that the future of technology is decentralised and open to all. We developed this project to contribute to making that future a reality."
                />

                <SectionVisionaries/>
                <SectionFounder/>

                <div className="relative py-16">

                    <SectionBuyACoffee/>
                </div>

            </div>
        </div>
    );
};

export default PageAbout;
